import React from 'react';
import Lottie from 'lottie-react-web';
import { Col, Row } from 'react-bootstrap';
import cpLoader from '../../assets/cp-loader.json';

const LoaderCP = () => {
  return (
    <div className="loader-cp container">
      <Row className="justify-content-center py-60">
        <Col lg={12}>
          <Lottie
            width={150}
            options={{
              animationData: cpLoader,
            }} />
          <h2 className="text-center">Estamos cargando esta sección</h2>
        </Col>
      </Row>
    </div>
  );
};

export default LoaderCP;
